import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { CreditCard, Sparkles, AlertTriangle } from 'lucide-react';
import { useRolePermissions } from '@/hooks/useRolePermissions';
import { HomeTemplate } from '@/components/templates/HomeTemplates';
import { useLanguage } from '@/contexts/LanguageContext';

const SubscriptionRequired: React.FC = () => {
  const { user } = useAuth();
  const { userRole, isPremium, isProfessional, isBasic } = useRolePermissions();
  const { direction } = useLanguage();
  
  return (
    <HomeTemplate>
      <div className="min-h-screen flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full space-y-8 bg-white p-6 rounded-lg shadow-lg">
          <div className="text-center">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
              <CreditCard className="h-8 w-8 text-amber-600" />
            </div>
            <h2 className="mt-6 text-3xl font-bold text-gray-900">
              {direction === 'rtl' ? 'נדרש מנוי פעיל' : 'Subscription Required'}
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              {direction === 'rtl' 
                ? 'כדי לגשת לתכונה זו, נדרש מנוי פעיל.'
                : 'To access this feature, an active subscription is required.'}
            </p>
          </div>
          
          <div className="mt-8 bg-gray-50 p-4 rounded-lg">
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <AlertTriangle className="h-5 w-5 text-amber-500 flex-shrink-0" />
              <p className="text-sm text-gray-700">
                {direction === 'rtl'
                  ? `סטטוס המנוי שלך: ${userRole?.subscription_status || 'לא פעיל'}`
                  : `Your subscription status: ${userRole?.subscription_status || 'inactive'}`}
              </p>
            </div>
            
            <div className="mt-4 flex items-center space-x-3 rtl:space-x-reverse">
              <Sparkles className="h-5 w-5 text-synagogue-gold flex-shrink-0" />
              <p className="text-sm text-gray-700">
                {direction === 'rtl'
                  ? `תכנית נוכחית: ${userRole?.plan_tier || 'בסיסית'}`
                  : `Current plan: ${userRole?.plan_tier || 'basic'}`}
              </p>
            </div>
          </div>
          
          <div className="mt-8 flex flex-col space-y-4">
            <Button asChild variant="default" className="w-full">
              <Link to="/subscription">
                {direction === 'rtl' 
                  ? 'שדרג את המנוי שלך'
                  : 'Upgrade Your Subscription'}
              </Link>
            </Button>
            
            <Button asChild variant="outline" className="w-full">
              <Link to="/dashboard">
                {direction === 'rtl'
                  ? 'חזרה לדשבורד'
                  : 'Back to Dashboard'}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </HomeTemplate>
  );
};

export default SubscriptionRequired; 